import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export interface IInfoBlockWithButtonTextDetails {
  buttonText: string;
  mainBlockText: string;
}

@Component({
  selector: 'app-info-block-with-button',
  templateUrl: './info-block-with-button.component.html',
  styleUrls: ['./info-block-with-button.component.scss']
})
export class InfoBlockWithButtonComponent implements OnInit {

  @Input() displayedTextDetails: IInfoBlockWithButtonTextDetails;
  @Input() disableButton: boolean;
  @Output() buttonClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Triggers once clicked on components button and emits the action
   */
  emitButtonClicked(): void {
    this.buttonClicked.emit();
  }

}
